<p>registrosobra works!</p>
<div class="p-6 bg-gray-900 text-white rounded-md max-w-lg">
    <form [formGroup]="formulario" (ngSubmit)="enviarFormulario()">
      <!-- Título -->
      <label class="block text-lg font-bold">
        Título <span class="text-red-500">Requerido</span>
      </label>
      <input 
        type="text" 
        formControlName="titulo"
        class="w-full bg-gray-800 p-2 mt-1 rounded border border-gray-600 focus:outline-none"
      />
  
      <!-- Presentación -->
      <label class="block mt-4 text-lg font-bold">Presentación</label>
      <textarea 
        formControlName="presentacion" 
        class="w-full bg-gray-800 p-2 mt-1 rounded border border-gray-600 focus:outline-none"
      ></textarea>
  
      <!-- Género -->
      <label class="block mt-4 text-lg font-bold">Género 1</label>
      <select 
        formControlName="genero" 
        class="w-full bg-gray-800 p-2 mt-1 rounded border border-gray-600"
      >
        <option value="">Selecciona un género</option>
        <option value="accion">Acción</option>
        <option value="drama">Drama</option>
        <option value="comedia">Comedia</option>
      </select>
  
      <!-- Idioma -->
      <label class="block mt-4 text-lg font-bold">Idioma de la obra</label>
      <select 
        formControlName="idioma" 
        class="w-full bg-gray-800 p-2 mt-1 rounded border border-gray-600"
      >
        <option value="ES">ES</option>
        <option value="EN">EN</option>
        <option value="FR">FR</option>
      </select>
  
      <!-- Tipo de Entrega -->
      <label class="block mt-4 text-lg font-bold">Tipo de entrega</label>
      <div class="flex gap-4 mt-2">
        <label class="flex items-center">
          <input type="radio" formControlName="tipoEntrega" value="one-shot" class="mr-2" />
          One shot
        </label>
        <label class="flex items-center">
          <input type="radio" formControlName="tipoEntrega" value="serie" class="mr-2" checked />
          Serie
        </label>
      </div>
  
      <!-- Serie Concluida -->
      <div class="mt-4">
        <label class="flex items-center">
          <input type="checkbox" formControlName="serieConcluida" class="mr-2" />
          Serie concluida
        </label>
      </div>

      <!-- Agregar Portada -->
      <div class="mt-4">
        <label class="block text-lg font-bold">Agregar Portada</label>
        <div class="upload-container"
             (click)="triggerFileInput()" 
             (dragover)="onDragOver($event)" 
             (dragleave)="onDragLeave($event)" 
             (drop)="onDrop($event)" 
             [class.dragover]="isDragging">
            <p>Arrastra y suelta el archivo aquí o haz clic para seleccionar</p>
            <input type="file" #fileInput (change)="onFileSelected($event)" hidden accept="image/jpeg, image/png">
        </div>
      </div>

      <div *ngIf="selectedFile" class="files-container">
        <h3>📁 Archivo seleccionado</h3>
        <ul>
          <li class="file-item">
            <div class="file-info">
                <button (click)="removeFile()" class="remove-btn">❌</button>
              <span class="file-name">{{ selectedFile.name }}</span>
              <span class="file-size">{{ formatSize(selectedFile.size) }}</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- Capitulo 1 -->
      <div class="mt-4">
        <label class="block text-lg font-bold">Capitulo 1</label>
        <label class="block text-lg font-bold">Agregar Paginas</label>
        <p>Solo se aceptan imágenes jpg, jpeg, png de tamaño máximo de 1,920×2,560</p>
        <div class="upload-container"
             (click)="triggerFileInputPages()" 
             (dragover)="onDragOverPages($event)" 
             (dragleave)="onDragLeavePages($event)" 
             (drop)="onDropPages($event)" 
             [class.dragover]="isDraggingPages">
            <p>Arrastra y suelta los archivos aquí o haz clic para seleccionar</p>
            <input type="file" #fileInputPages (change)="onFilesSelectedPages($event)" multiple hidden accept="image/jpeg, image/png">
        </div>
      </div>

      <div *ngIf="selectedPages.length > 0" class="files-container">
        <h3>📁 Páginas seleccionadas</h3>
        <ul>
          <li *ngFor="let file of selectedPages; let index = index" class="file-item">
            <div class="file-info">
              <button (click)="removePage(index)" class="remove-btn">❌</button>
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">{{ formatSize(file.size) }}</span>
            </div>
          </li>
        </ul>
      </div>
  
      <!-- Botón de Envío -->
      <button 
        type="submit"
        class="mt-6 w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
      >
        Enviar
      </button>
    </form>
  </div>